import React, { useEffect, useState } from "react";
import { SelectDevices } from "./SelectDevices";
import { getBasicCameraData } from "../../../services/data/getAllCamsData";

const TITLE = "Camera devices";

const SelectCameraDevices = ({ selectedDevices, onChange, loadingDevices, disabled }) => {
  const [data, setData] = useState([]); // The camera devices ids and labels.

  // Get the camera ids and labels.
  useEffect(() => {
    const fetchData = async () => {
      loadingDevices.add(1);
      const data = await getBasicCameraData();
      setData(data);
      onChange(data);
      loadingDevices.done();
    };
    fetchData();
  }, []);

  return (
    <SelectDevices
      selectedDevices={selectedDevices}
      onChange={onChange}
      title={TITLE}
      data={data}
      disabled={disabled}
    />
  );
};

export default SelectCameraDevices;
